export type AccountPlatform = 'onlyfans' | 'fansly';

export function isMassMessagesTabVisible(
  _platform: AccountPlatform,
  hasMassMessagesAccess: boolean,
): boolean {
  return hasMassMessagesAccess;
}
